module.exports = __webpack_public_path__ + "static/media/host-link-icon.b7610e6d.svg";